import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCurators = lazy(() => import("@/pages/admin/AdminCurators"));

export const Route = createFileRoute("/admin/curators")({
  component: AdminCurators,
});
